import { MenuHero } from "../components/menu/MenuHero";
import { MenuGrid } from "../components/menu/MenuGrid";
import { MenuCTA } from "../components/menu/MenuCTA";
import { Seo } from "../components/Seo";

export default function Menu() {
  return (
    <main data-testid="menu-page" className="bg-deepred">
      <Seo
        title="Menu"
        description="Explore the Chicken Labb menu — signature baskets, sandwiches, hot chicken, tenders, sauces and sides. Every recipe engineered and field-tested in New Jersey."
        path="/menu"
      />
      <MenuHero />
      <MenuGrid />
      <MenuCTA />
    </main>
  );
}
